import { NavLink } from 'react-router-dom';
import { useAppSelector } from '@store';
import {
  ButtonPseudo,
  ButtonSize,
  IconExpand,
  IconRefresh,
  PermissionEnum,
  Table,
} from '@ui/src';
import Card from '../../../../components/common/card/card';
import { MonitoringRulesTypes } from '../types';
import useMonitoringRules from '../hooks/use-monitoring-rules';
import {
  transactionMonitoringRulesColumns,
  transactionMonitoringRulesColumnsLabels,
} from '../variables/monitoring-rules';

import cn from '../styles.module.css';
import { OrganizationType } from '../../types';

const MonitoringRules = ({
  activePermissions,
  customerId,
  type,
}: MonitoringRulesTypes) => {
  const { monitoringRules, monitoringRulesErrorsList } = useAppSelector(
    (state) => state.customerAml,
  );

  const {
    formattedData,
    filters,
    onTableFilterChange,
    isLoading,
    filtersComponent,
    handleSubmit,
    errorList,
    onTableSetPage,
    onRowClick,
  } = useMonitoringRules({
    monitoringRules,
    activePermissions,
    customerId,
  });

  return (
    <Card
      titleContent={
        <>
          <div
            className={`${cn.ongoingTitleWrapper} ${cn.monitoringRulesTitleWrapper}`}
          >
            <div className={cn.ongoingTitleLeft}>
              <div className={`${cn.ongoingTitle} ${cn.monitoringRulesTitle}`}>
                Monitoring rules
              </div>
            </div>

            <div className={cn.ongoingTitleRight}>
              <ButtonPseudo
                text="Refresh"
                icon={<IconRefresh />}
                size={ButtonSize.SMALL}
                className={cn.reloadMonitoringRulesButton}
                onClick={() => onTableFilterChange(filters)}
              />
              {activePermissions?.includes(
                PermissionEnum.AML_MONITORING_RULES_ADD_ACTION,
              ) && (
                <NavLink
                  to="/transaction-monitoring-rules/create"
                  className={`${cn.ongoingExport} ${cn.createMonitoringRule}`}
                  target="_blank"
                  onClick={() =>
                    localStorage.setItem(
                      'newRuleState',
                      JSON.stringify({
                        clientType:
                          type === OrganizationType.INDIVIDUAL
                            ? 'INDIVIDUAL'
                            : 'CORPORATE',
                        entity: 'TRANSACTION',
                        organizationIds: customerId,
                      }),
                    )
                  }
                >
                  <IconExpand />
                  Add rule
                </NavLink>
              )}
            </div>
          </div>
          <div className={cn.monitoringRulesDescription}>
            Customer-specific rules applied in addition to general rules
          </div>
        </>
      }
    >
      <div className={cn.monitoringRulesTableWrapper}>
        <Table
          columns={transactionMonitoringRulesColumns}
          data={formattedData || []}
          onSort={() => {}}
          filters={filters}
          sort={{}}
          columnsLabels={transactionMonitoringRulesColumnsLabels}
          onFilterChange={(data) => onTableFilterChange(data)}
          tableClassName={!formattedData?.length ? cn.emptyTable : ''}
          tableBodyClassName={!monitoringRules?.length ? cn.emptyOngoing : ''}
          isLoading={isLoading}
          filtersComponent={filtersComponent}
          handleSubmit={handleSubmit}
          take="30"
          setPage={(data) => onTableSetPage(data)}
          onRowClick={onRowClick}
          error={monitoringRulesErrorsList || errorList}
        />
      </div>
    </Card>
  );
};

export default MonitoringRules;
